import React, { FC, Fragment } from "react";
import injectSheet from "react-jss";
import styleSheet from "./styles";
import { Button } from "Components/Buttons";

interface Props {
  name?: string;
  classes?: any;
  onCancel?: () => void;
  onDelete?: () => void;
  disabled?: boolean;
  errorMessage?: string;
}

const DeleteList: FC<Props> = props => {
  return (
    <div className={props.classes.container}>
      <p>
        Are you sure you want to permanently delete{" "}
        <span style={{ wordBreak: "break-all" }}>{props.name}</span>?
      </p>
      {props.errorMessage && (
        <div className={props.classes.error}>{props.errorMessage}</div>
      )}
      <div className={props.classes.controls}>
        <Button onClick={props.onCancel} buttonType={"defaultClear"}>
          Cancel
        </Button>
        <Button
          disabled={props.disabled}
          onClick={props.onDelete}
          buttonType={"defaultRed"}
        >
          Delete
        </Button>
      </div>
    </div>
  );
};

export default injectSheet(styleSheet)(DeleteList);
